// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1laak","main":"styles-module--main--1HfsX"};